/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DirectMessageStatus } from './DirectMessageStatus';
import {
    DirectMessageStatusFromJSON,
    DirectMessageStatusFromJSONTyped,
    DirectMessageStatusToJSON,
    DirectMessageStatusToJSONTyped,
} from './DirectMessageStatus';

/**
 * Direct message API response with sender info
 * @export
 * @interface IDirectMessageResponse
 */
export interface IDirectMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    conversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    senderId?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    senderUsername?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    senderAvatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    recipientId?: string;
    /**
     * 
     * @type {string}
     * @memberof IDirectMessageResponse
     */
    content?: string;
    /**
     * 
     * @type {DirectMessageStatus}
     * @memberof IDirectMessageResponse
     */
    status?: DirectMessageStatus;
    /**
     * 
     * @type {number}
     * @memberof IDirectMessageResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof IDirectMessageResponse
     */
    readAt?: number;
}



/**
 * Check if a given object implements the IDirectMessageResponse interface.
 */
export function instanceOfIDirectMessageResponse(value: object): value is IDirectMessageResponse {
    return true;
}

export function IDirectMessageResponseFromJSON(json: any): IDirectMessageResponse {
    return IDirectMessageResponseFromJSONTyped(json, false);
}

export function IDirectMessageResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDirectMessageResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'conversationId': json['conversationId'] == null ? undefined : json['conversationId'],
        'senderId': json['senderId'] == null ? undefined : json['senderId'],
        'senderUsername': json['senderUsername'] == null ? undefined : json['senderUsername'],
        'senderAvatarUrl': json['senderAvatarUrl'] == null ? undefined : json['senderAvatarUrl'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'content': json['content'] == null ? undefined : json['content'],
        'status': json['status'] == null ? undefined : DirectMessageStatusFromJSON(json['status']),
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'readAt': json['readAt'] == null ? undefined : json['readAt'],
    };
}

export function IDirectMessageResponseToJSON(json: any): IDirectMessageResponse {
    return IDirectMessageResponseToJSONTyped(json, false);
}

export function IDirectMessageResponseToJSONTyped(value?: IDirectMessageResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversationId': value['conversationId'],
        'senderId': value['senderId'],
        'senderUsername': value['senderUsername'],
        'senderAvatarUrl': value['senderAvatarUrl'],
        'recipientId': value['recipientId'],
        'content': value['content'],
        'status': DirectMessageStatusToJSON(value['status']),
        'createdAt': value['createdAt'],
        'readAt': value['readAt'],
    };
}

